import _, { isString } from 'lodash'
import produce from 'immer'
import { FeatureName, FeatureValue, FeatureValues } from './types'
import { getFeatureNames, getFeatureType, isSupportedFeature } from './featuresSchemaService'

export function getEnvFeatures(): FeatureValues {
  const features = getParsedEnvFeatures()
  return _.pickBy(
    features,
    (value): value is string | boolean =>
      value !== '' && value !== null && !isFeaturePlaceholder(value)
  )
}

function isFeaturePlaceholder(value: string | boolean) {
  return isString(value) && value.startsWith('__') && value.endsWith('__')
}

const getUnparsedFeaturesFromWindow = () => {
  const _window = window as any

  return produce({} as Record<FeatureName, string>, draft => {
    getFeatureNames().forEach(name => {
      if (_window[name]) {
        draft[name] = _window[name]
      }

      if (_window[`FEATURE_${name}`]) {
        draft[name] = _window[`FEATURE_${name}`]
      }
    })
  })
}

export function getParsedEnvFeatures(): Partial<Record<FeatureName, FeatureValue>> {
  // const unparsedFeatures = _.pick(window, getWindowFeatureProps())
  const unparsedFeatures = getUnparsedFeaturesFromWindow()
  return _.mapValues(unparsedFeatures, (v, k: FeatureName) => parseStringifiedFeatureValue(k, v))
}

export function parseStringifiedBoolean(flag: string): boolean | null {
  if (flag === '') {
    return null
  }

  if (flag === '1' || flag === 'true') {
    return true
  }

  return false
}

export const parseStringifiedFeatureValue = (featName: FeatureName, valueAsString: string) => {
  if (!isSupportedFeature(featName)) throw new Error('Nice try, guy q:^)')

  if (getFeatureType(featName) === 'boolean') {
    return parseStringifiedBoolean(valueAsString)
  }

  return valueAsString
}
